import React from 'react';
import { compose } from 'redux';
import { Icon, Loader, Button } from 'react-inv-forms';

import withTableClickableModalsHandler, {
  WithTableClickableModalsHandlerProps,
} from '../../../hoc/withTableClickableModalsHandler';

import { FiltersContainer, FilterContainer } from './Filter.style';
import { FilterBox } from '../../UI/FilterBox';

import arrowDown from '../../../images/arrowDown.svg';
import arrowDownGrey from '../../../images/arrowDownGrey.svg';
import arrowUpRed from '../../../images/arrowUpRed.svg';
import close from '../../../images/close.svg';

interface Props extends WithTableClickableModalsHandlerProps {
  /** informacje o dostępnych grupach filtrów */
  filterGroups: FilterData[];
  /** funkcja wywołana przy wyborze filtrów z filtra głównego */
  onFilterSelection: (e: Array<string>) => void;
  /** funkcja wywołana orzy wyborze opcji filtrującej */
  onFilterChange: (value: string, e: Array<string>) => void;
  /** funkcja przekazująca nazwę filtru do dezaktywacji */
  onFilterDisable: (name: string) => void;
  /** obiekt z wymaganymi translacjami */
  translations: {
    [key: string]: React.ReactElement;
  };
  /** stan ładowania listy filtrów */
  loadingFilterList: boolean;
}

/**
 * Komponent uruchamiający wybrane filtry danych tabeli
 *
 */
export class Filter extends React.Component<Props> {
  /* Funkcja obsługująca dezaktywację grupy filtrów */
  disableFilter = (name: string): void => {
    this.props.closeModal();
    this.props.onFilterDisable(name);
  };
  render(): React.ReactElement {
    const { filterGroups } = this.props;
    /* Konwersja danych dla głównego filtra w celu poprawnego wyświetlenia pól wyboru */
    const mainFilterData = filterGroups.map(filter => ({
      label: filter.title,
      value: filter.name,
      disabled: filter.isDefault,
    }));
    const activeGroups = this.props.filterGroups.filter(group => group.active).map(group => group.name);
    return (
      <FiltersContainer>
        <FilterContainer id='main'>
          <Button
            onClick={this.props.openModal.bind(null, 'main')}
            disabled={this.props.filterGroups.length === 0}
            data-cy='btnAddFilter'
          >
            {this.props.translations.mainFilter}
            {this.props.loadingFilterList ? (
              <Loader style={{ color: `${this.props.filterGroups.length === 0 ? '#70707065' : '#fff'}`, fontSize: '16px' }} />
            ) : (
              <Icon path={this.props.filterGroups.length === 0 ? arrowDownGrey : arrowDown} />
            )}
          </Button>
          {this.props.openedModals.includes('main') ? (
            <FilterBox
              selectedValues={activeGroups}
              onClose={this.props.closeModal}
              opened={this.props.openedModals.includes('main')}
              title={this.props.translations.mainFilter}
              options={mainFilterData}
              onChange={this.props.onFilterSelection}
              type='checkbox'
              loading={this.props.loadingFilterList}
              noFilters={this.props.translations.noData}
            />
          ) : null}
        </FilterContainer>
        {filterGroups.map((filter, idx) => {
          if (filter.active) {
            const displaySelected = filter.values
              .map(value => (filter.selected.includes(value.value) ? value.label : null))
              .filter(value => value !== null);

            const displayLabels = filter.selected.length === displaySelected.length ? displaySelected : filter.selectedValues;

            return (
              <FilterContainer key={`filter_${idx}`}>
                <Button
                  outlined={true}
                  onClick={this.props.openModal.bind(null, filter.name)}
                  disabled={filter.loading}
                  data-cy={`btnFilter_${filter.name}`}
                >
                  {displayLabels.length && !filter.loading
                    ? displayLabels.map((item, idx) => (
                        <span key={`${idx}`} className='selected'>
                          {item}
                          {filter.selectedValues[idx + 1] ? ',' : ''}
                        </span>
                      ))
                    : filter.title}
                  {filter.selected.length && !filter.loading && filter.values.length === 0 ? filter.title : ''}
                  {filter.loading && <Loader style={{ fontSize: '16px' }} />}
                  {filter.isDefault && !filter.loading && <Icon path={arrowUpRed} style={{ transform: 'rotate(180deg)' }} />}
                  {!filter.isDefault && !filter.loading && (
                    <React.Fragment>
                      <Icon path={arrowUpRed} style={{ transform: 'rotate(180deg)' }} />
                      <Icon path={close} onClick={this.disableFilter.bind(null, filter.name)} />
                    </React.Fragment>
                  )}
                </Button>
                {this.props.openedModals.includes(filter.name) ? (
                  <FilterBox
                    selectedValues={filter.selected}
                    onClose={this.props.closeModal}
                    opened={this.props.openedModals.includes(filter.name)}
                    title={filter.title}
                    options={filter.values}
                    onChange={this.props.onFilterChange.bind(null, filter.name)}
                    type={filter.type}
                    loading={filter.loading && this.props.loadingFilterList}
                    noFilters={this.props.translations.noData}
                  />
                ) : null}
              </FilterContainer>
            );
          }
        })}
      </FiltersContainer>
    );
  }
}
export default compose(withTableClickableModalsHandler)(Filter) as React.ComponentType<any>;
